import React from "react";
import { useParams, Link } from "react-router-dom";
import newsEntries from "./newsData";
import "./NewsDetail.css";

const NewsDetail = () => {
  const { slug } = useParams();
  const entry = newsEntries.find((item) => item.slug === slug);

  if (!entry) {
    return (
      <div className="news-detail-page">
        <div className="news-detail-container">
          <p>Sorry, we couldn’t find that story.</p>
          <Link to="/news-events" className="detail-back">
            ← Back to News & Events
          </Link>
        </div>
      </div>
    );
  }

  const gallery = entry.gallery || [];
  const heroImage = gallery[0] || null;
  const middleImage = gallery[1] || null;
  const bottomImage = gallery[2] || null;
  const paragraphs = entry.content;
  const middleIndex = Math.floor(paragraphs.length / 2);

  return (
    <div className="news-detail-page">
      <section className="news-detail-container">
        <Link to="/news-events" className="detail-back top">
          ← Back to News & Events
        </Link>

        <header className="detail-heading">
          <p className="detail-eyebrow">{entry.tag}</p>
          <h1>{entry.title}</h1>
          <p className="detail-date">{entry.date}</p>
        </header>

        <article className="detail-body">
          {heroImage && (
            <div className="detail-image detail-image--hero">
              <img
                src={heroImage}
                alt={`${entry.title} highlight`}
                loading="eager"
                fetchPriority="high"
                decoding="async"
              />
            </div>
          )}

          <div className="detail-text">
            {paragraphs.map((text, index) => (
              <React.Fragment key={text + index}>
                <p>{text}</p>
                {middleImage && index === middleIndex && (
                  <div className="detail-image detail-image--middle">
                    <img
                      src={middleImage}
                      alt={`${entry.title} visual ${index + 2}`}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>

          {bottomImage && (
            <div className="detail-image detail-image--bottom">
              <img
                src={bottomImage}
                alt={`${entry.title} visual closing`}
                loading="lazy"
                decoding="async"
              />
            </div>
          )}

          {entry.quotes?.length > 0 && (
            <div className="detail-quotes">
              {entry.quotes.map((quote) => (
                <blockquote key={quote}>{quote}</blockquote>
              ))}
            </div>
          )}
        </article>

      </section>
    </div>
  );
};

export default NewsDetail;

